import SHARED_META from './shared'
import { SHARED_META_ASDA } from './asda.shared'

export default {
  en_GB: {
    title: 'Log into your patient account - Asda Online Doctor',
    meta: [
      ...SHARED_META,
      ...SHARED_META_ASDA,
      {
        property: 'og:title',
        content: 'Log into your patient account - Asda Online Doctor'
      },
      {
        property: 'og:description',
        content: 'Asda Online Doctor is an Online Doctor providing convenient online medical assessment and fast delivery of prescription treatments, without needing to see a doctor face-to-face.'
      },
      {
        property: 'og:url',
        content: 'https://onlinedoctor.asda.com/uk/'
      },
      {
        property: 'og:image',
        content: 'https://onlinedoctor.asda.com/uk/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'twitter:title',
        content: 'Log into your patient account - Asda Online Doctor'
      },
      {
        name: 'twitter:description',
        content: 'ASDA is an Online Doctor providing convenient online medical assessment and fast delivery of prescription treatments, without needing to see a doctor face-to-face.'
      },
      {
        name: 'twitter:image',
        content: 'https://onlinedoctor.asda.com/uk/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/ms-icon-144x144.png'
      }
    ],
    link: [
      {
        rel: 'apple-touch-icon',
        sizes: '57x57',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-57x57.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '60x60',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-60x60.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '72x72',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-72x72.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-76x76.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '114x114',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-114x114.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-120x120.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '144x144',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-144x144.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-152x152.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/apple-icon-180x180.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/android-icon-192x192.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/favicon-32x32.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/favicon-96x96.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'https://onlinedoctor.asda.com/uk/assets/dist/images/favicons/asda/favicon-16x16.png'
      }
    ]
  }
}
